/**
 * Grants domain — cache invalidation registry.
 *
 * Every grants mutation invalidates the shared list cache via
 * `commonGrantInvalidations()`. There are no legacy string keys to
 * coordinate with: this PR migrated every grants consumer onto the
 * generated hooks in a single pass, so `listGrantsQueryKey()` is the
 * only cache the table or reminder calendar dropdown actually reads.
 */

import type { QueryKey } from '@tanstack/react-query'

import { type InvalidationRule } from '../invalidation/useInvalidatingMutation'
import { listGrantsQueryKey } from '../generated/hooks/grantsController'

export type GrantsMutationId = 'updateGrantPreferences' | 'deleteGrant'

export function commonGrantInvalidations(): QueryKey[] {
  return [listGrantsQueryKey()]
}

export const invalidationRegistry: Record<
  GrantsMutationId,
  InvalidationRule<any>
> = {
  updateGrantPreferences: {
    invalidates: () => commonGrantInvalidations(),
  },
  deleteGrant: {
    invalidates: () => commonGrantInvalidations(),
  },
}
